export default {"src":"/_next/static/media/checkbox_disabled_on.86da128e.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};